﻿import React from 'react';
import styled from 'styled-components';
import control from '../../../vendor/react-validation/hocs/control';

import definitions from '../../Style/LfStyleDefinitions';
import {iconCode, mediaQuery, clearFix} from '../../Style/cssHelpers';

const NumberInput = ({ error, isChanged, isUsed, ...allProps }) => {
    const { displayname, theme, colorScheme, innerLabel, padding, noMarginBottom, customTextAlign, ...props } = allProps;

    return (
        <NumberInputWrapper
            theme={theme}
            colorScheme={colorScheme}
            innerLabel={innerLabel}
            customTextAlign={customTextAlign}
            padding={padding}
            noMarginBottom={noMarginBottom}
        >
            <label htmlFor={props.id} className="visually-hidden">{props.id}</label>
            <input type="number" inputMode="numeric" pattern="[0-9]*"
                {...props} {...( isChanged && isUsed && error
                    ? {
                        className: `is-invalid-input ${props.className}`
                    }
                    : {
                        className: props.className
                    } )
                }
            />
            {isChanged && isUsed && error}
        </NumberInputWrapper>
    );
}

const numberPropsToExclude = ['innerLabel', 'customTextAlign', 'noMarginBottom', 'theme', 'padding', 'colorScheme' ]

const NumberInputWrapper = styled.div.withConfig({
shouldForwardProp: (prop) => !numberPropsToExclude.includes(prop)
})`
    position: relative;
    text-align: ${props => props.customTextAlign ? props.customTextAlign : 'left'};

    input[type=number] {
        background-color: ${definitions.colors.grayBackground};
        border: 1px solid ${definitions.colors.grayBorder};
        font-family: ${definitions.fonts.main};
        font-size: 18px;

        width: 75px;
        border-radius: 40px;
        padding: 12px;
        margin-bottom: ${props => props.noMarginBottom ? '0px' : '10px'};

        text-align: center;
        -moz-appearance: textfield;

        ${mediaQuery.medium(`
            font-size: 16px;
        `)}

        ${mediaQuery.small(`
            font-size: 13px;
            padding: 5px;
            width: 35px;
        `)}
    }

    input[type=number]::placeholder {
        opacity: 0.3;
        text-align: center;
    }

    input[type=number].is-invalid-input {
        border: 1px solid ${definitions.colors.error};
        margin-bottom: 0;
    }

    ${props => props.theme === 'big' ? `
        display: inline-block;
        max-width: 160px;

        input[type=number] {
            position: relative;
            -moz-appearance: textfield !important;

            width: 160px;
            height: 86px;

            ${mediaQuery.small(`
                height: 70px;
            `)}

            ${props.padding === 'small' ? `
                padding: 10px 54px 10px 2px;
            ` : `
                padding: 12px 10px 12px 0px;
            `}

            background-color: transparent;
            -webkit-appearance: none;

            text-align: center;
            font-size: 22px;
            font-family: ${definitions.fonts.heading};
            font-weight: bold;
            color: ${definitions.colors.almostBlack};

            ${props.colorScheme == 'white' ? `
                color: white;
                border-radius: 0;
                background-color: rgba(255, 255, 255, 0.3);
                border: none;
            `:''};

            border-radius: 0;
        }

        input[type=number]::-webkit-inner-spin-button,
        input[type=number]::-webkit-outer-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }

        &:after {
            content: "${props.innerLabel}";
            position: absolute;
            z-index: 99;
            left: 105px;
            top: 25px;

            ${mediaQuery.small(`
                top: 17px;
                left: 105px;
            `)}

            font-size: 22px;
            font-family: ${definitions.fonts.heading};
            font-weight: bold;
            color: ${definitions.colors.almostBlack};

            ${props.colorScheme == 'white' ? `
                color: white;
            `:''};
        }` : ''
    }
`;

export default control(NumberInput);
